export const PORTAL_MODAL_SELECTOR = '[data-portal-layer="modal"]'

export function isInsidePortalModal(el) {
    return Boolean(el?.closest(PORTAL_MODAL_SELECTOR))
}
